import dayjs from "dayjs";

export function formatMetadataValue(type: string, value: string): string {
  switch (type) {
    case 'text':
    case 'number':
      return value;
    case 'date':
      return dayjs(value).format("YYYY-MM-DD");
    case 'datetime':
      return value; // Send datetime value without transformation
    default: 
      return value;
  }
}